<script>
  import { Modal } from "carbon-components-svelte";
  import { TextInput, Button, Pagination } from "paxray-components-svelte";
  import { EDIT_ICON, PLUS_ICON, CLOSE_ICON } from "@utils/icons.js";

  export let rules = [];
  export let selectedRule = "";
  export let createRule = () => {};
  export let updateRule = () => {};
  export let removeRule = () => {};

  let searchTerm = "";
  let modalOpen = false;
  let currentPage = 1;
  let filteredRules = [];
  let displayCount = 5;
  let displayedRules = [];
  let deleteModalOpen = false;
  let editRuleName = "";

  $: updateDisplay(currentPage, searchTerm, rules);

  function selectRule(id) {
    if (selectedRule === id) selectedRule = "";
    else selectedRule = id;
  }

  function deleteRule() {
    removeRule(selectedRule);
    rules = rules.filter((rule) => rule.id !== editRuleName);
    selectedRule = "";
    editRuleName = "";
    deleteModalOpen = false;
  }

  function saveRule() {
    if (selectedRule) {
      updateRule(editRuleName);
      rules = rules.map((rule) => {
        if (rule.name === editRuleName) {
          return editRuleName;
        }
        return rule;
      });
    } else {
      createRule(editRuleName);
    }
  }

  function updateDisplay(currentPage, search, sortedRules) {
    if (search) {
      filteredRules = sortedRules.filter((rule) =>
        rule.name.toLowerCase().includes(search.toLowerCase()),
      );
    } else {
      filteredRules = sortedRules;
    }
    while (filteredRules.length < (currentPage - 1) * displayCount) {
      currentPage--;
    }
    displayedRules = filteredRules.slice(
      (currentPage - 1) * displayCount,
      currentPage * displayCount,
    );
  }
</script>

<div class="app_selection_wrapper">
  <div class="top_bar">
    <div class="search_wrapper">
      <div class="search">
        <div class="searchicon">
          <svg
            height="100%"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.1466 24L14.8751 14.4151C14.077 15.0963 13.1462 15.6125 12.0828 15.9637C11.0193 16.3149 9.96862 16.4906 8.9306 16.4906C6.45541 16.4906 4.36059 15.6939 2.64614 14.1005C0.931688 12.5071 0.0744629 10.5574 0.0744629 8.25144C0.0744629 5.94545 0.928225 3.99371 2.63575 2.39623C4.3433 0.798742 6.42958 0 8.89461 0C11.3596 0 13.4579 0.797296 15.1894 2.39189C16.921 3.98645 17.7867 5.93492 17.7867 8.23728C17.7867 9.26149 17.5845 10.2704 17.1802 11.2642C16.7758 12.2579 16.2231 13.1069 15.5222 13.8113L25.7937 23.3585L25.1466 24ZM8.9306 15.6604C11.1705 15.6604 13.0582 14.9497 14.5938 13.5283C16.1293 12.1069 16.8971 10.3459 16.8971 8.24528C16.8971 6.14465 16.1293 4.38365 14.5938 2.96226C13.0582 1.54088 11.1705 0.830189 8.9306 0.830189C6.69074 0.830189 4.80302 1.54088 3.26744 2.96226C1.7319 4.38365 0.964121 6.14465 0.964121 8.24528C0.964121 10.3459 1.7319 12.1069 3.26744 13.5283C4.80302 14.9497 6.69074 15.6604 8.9306 15.6604Z"
              fill="#1C1C20"
            />
          </svg>
        </div>
        <input
          type="text"
          bind:value={searchTerm}
          placeholder="Search for Rule"
        />
      </div>
    </div>
    <div>
      <Button
        kind="secondary"
        iconDescription="New"
        icon={PLUS_ICON}
        on:click={() => {
          selectedRule = "";
          modalOpen = true;
        }}
      />
    </div>
  </div>
  <div class="activities">
    {#each displayedRules as rule}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        class="activity"
        on:click={() => {
          selectRule(rule.id);
        }}
      >
        <div
          class="rule_name"
          style={selectedRule == rule.id ? "border:1px solid black;" : ""}
        >
          <span>{rule.name}</span>
        </div>
        <Button
          kind="secondary"
          icon={EDIT_ICON}
          on:click={(e) => {
            e.stopPropagation();
            selectedRule = rule.id;
            editRuleName = rule.name;
            modalOpen = true;
          }}
        />
        <Button
          kind="secondary"
          icon={CLOSE_ICON}
          on:click={(e) => {
            e.stopPropagation();
            selectedRule = rule.id;
            editRuleName = rule.name;
            deleteModalOpen = true;
          }}
        />
      </div>
    {/each}
  </div>

  <Pagination
    basic
    totalItems={filteredRules.length}
    bind:page={currentPage}
    pageSize={displayCount}
  />
</div>

<Modal
  open={deleteModalOpen}
  preventCloseOnClickOutside
  modalHeading="Delete Rule"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  danger
  on:click:button--secondary={() => {
    deleteModalOpen = false;
  }}
  on:submit={() => {
    deleteRule();
  }}
>
  <p>Are you sure you want to delete this rule?</p>
</Modal>

<Modal
  size="lg"
  preventCloseOnClickOutside
  open={modalOpen}
  modalHeading={selectedRule ? "Edit Rule" : "Add Rule"}
  primaryButtonText="Save"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    modalOpen = false;
  }}
  on:open
  on:close={() => {
    modalOpen = false;
    editRuleName = "";
  }}
  on:submit={() => {
    saveRule();
    modalOpen = false;
  }}
>
  <TextInput
    labelText="Name"
    placeholder="Enter name for Rule"
    bind:value={editRuleName}
  />
</Modal>

<style>
  .app_selection_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .search_wrapper {
    display: flex;
    gap: 0.5rem;
    flex-grow: 1;
    width: 100%;
    flex-shrink: 1;
    flex-grow: 1;
  }

  .search {
    border: 1px solid var(--pax-black);
    border-radius: 0.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    height: 3rem;
    padding: 0 1rem;
  }

  .searchicon {
    height: 1.5rem;
  }

  input {
    border: none;
    padding-left: 1rem;
    width: 90%;
  }

  input:focus,
  input:active {
    outline: none;
  }

  .top_bar {
    display: flex;
    gap: 0.5rem;
  }

  .activities {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .activity {
    display: flex;
    gap: 0.5rem;
    width: 100%;
    max-width: 100%;
  }

  /* .rule {
    display: flex;
    gap: 0.5rem;
    width: 100%;
    max-width: 100%;
  }

  .color {
    height: 3rem;
    aspect-ratio: 1/1;
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
  } */

  .rule_name {
    display: flex;
    height: 3rem;
    align-items: center;
    flex-grow: 1;
    flex-shrink: 1;
    background-color: var(--pax-smoke);
    padding: 0 1rem;
    border-radius: 0.5rem;
    width: 100%;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .rule_name span {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
